<template>
    <BaseLink
        :class="[$style.base_button_override, $style.mobile_override, !!user && $style.mobile_auth_override]"
        data-interface-target="youtube-header-button"
        :externalTo="YOUTUBE_HEADER_URL"
        target="_blank"
    >
        <img
            :class="$style.icon"
            :src="YoutubeImg"
            alt="Youtube"
        />
    </BaseLink>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import BaseLink from '@/components/BaseLink.vue'
import { YOUTUBE_HEADER_URL } from '@/constants/general'
import { useUserStore } from '@/store/user-store/user-store'

import YoutubeImg from './images/youtube.svg'

const { user } = storeToRefs(useUserStore())
</script>

<style module>
.base_button_override {
    width: 48px;
    height: 48px;
    border-radius: 1000px;
    background: var(--carbon-400);
}

.mobile_override {
    display: none;
}

/* Visible at 382px+ regardless of auth state */
@media (min-width: 382px) {
    .mobile_override {
        display: block;
    }
}

/* Visible at 360px+ for authenticated users */
@media (min-width: 360px) {
    .mobile_auth_override {
        display: block;
    }
}

.icon {
    width: 48px;
    height: 48px;
}

@media (--desktop-small-plus) {
    .base_button_override {
        transition: box-shadow 0.3s;
        padding: 4px;
    }

    .base_button_override:hover,
    .base_button_override:focus {
        box-shadow: 0 0 30px 0 rgba(163, 109, 253, 0.64) inset;
        outline: 0.5px solid var(--purple-300);
    }
}
</style>
